/** Formats a numeric percentage value for display on `proffeo-ui-slider`'s `displayWith` input (e.g. `75 %`). */
export function formatPercentageValue(percentageValue: number): string {
  return `${percentageValue} %`;
}
